import script from "./SiteStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteStats.vue?vue&type=script&setup=true&lang=ts"

import "./SiteStats.vue?vue&type=style&index=0&id=1a00ac1a&lang=css"

const __exports__ = script;

export default __exports__